import styles from './expander.module.css';
import { MaterialSymbolIcon } from '@/components/material-symbol-link';

interface ExpanderProps {
  icon: React.ReactNode;
  title: string;
  indicatorText: string;
  children: React.ReactNode;
  collapsedText?: string;
  isOpen?: boolean;
  onClick?: () => void;
}

export function Expander({
  icon,
  title,
  indicatorText,
  collapsedText,
  children,
  isOpen = false,
  onClick,
}: ExpanderProps) {
  return (
    <div className={styles.container}>
      <button className={styles.expander} onClick={onClick}>
        <span className={styles.expanderTitle}>
          {icon}
          {title}
        </span>
        <span className={styles.expanderIndicator}>
          {indicatorText}
          <MaterialSymbolIcon name={isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'} />
        </span>
      </button>
      {(isOpen || !!collapsedText) && (
        <div className={styles.content}>
          {isOpen ? children : <span className={styles.truncatedText}>{collapsedText}</span>}
        </div>
      )}
    </div>
  );
}
